import { RootState } from 'store';

export const selectClientPackageSchedules = ({ main }: RootState) => main.clientPackageSchedules.rows;
export const selectClientPackageScheduleByPackageId = ({ main }: RootState, package_fixed_id: string | number) =>
  main.clientPackageSchedules.rows.find((item) => Number(package_fixed_id) === item.package.id);

export const selectLookupClientPackageSchedules = ({ main }: RootState) =>
  main.clientPackageSchedules.rows.map((item) => ({
    id: item.id,
    name: item.package.name,
  }));
